import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGiftBox: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="gift-box, present"><path d="M2 7.40909C2 5.5263 3.5263 4 5.40909 4H11.25V9H3.59091C2.71227 9 2 8.28773 2 7.40909Z" fill="currentColor"/><path d="M3 10.5H11.25V20H6.75C4.67893 20 3 18.3211 3 16.25V10.5Z" fill="currentColor"/><path d="M12.75 4H18.5909C20.4737 4 22 5.5263 22 7.40909C22 8.28773 21.2877 9 20.4091 9H12.75V4Z" fill="currentColor"/><path d="M12.75 10.5H21V16.25C21 18.3211 19.3211 20 17.25 20H12.75V10.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconGiftBox;
